import axios from 'axios';
import { onRequest } from './interceptors/request.interceptor';
import { onResponse } from './interceptors/response.interceptor';
import { onError } from './interceptors/error.interceptor';

/**
 * Configure the base Axios instance.
 */
const axiosInstance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_URL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Attach interceptors
axiosInstance.interceptors.request.use(onRequest);
axiosInstance.interceptors.response.use(onResponse, onError);

export { axiosInstance };
